module.exports = __webpack_public_path__ + "64631b2d08ddaa06df4c6a9afa4a94b2.jpg";